/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import Moment from 'moment';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';

class EstrattoContoFilter extends Component {
    constructor(props) {
        super(props);

        let dataDalField = Moment().format("YYYY") + "/" + Moment().format("MM") + "/";
        let dataAlField = Moment().format("YYYY") + "/12/";

        let fields = {itemDal: dataDalField, itemAl: dataAlField};
        if (props.itemDal !== undefined && props.itemAl !== undefined){
            fields = Object.assign(fields, {itemDal: props.itemDal, itemAl: props.itemAl});
        }
        else if (props.itemDal !== undefined){
            fields = Object.assign(fields, {itemDal: props.itemDal, itemAl: null});
        } else if (props.itemAl !== undefined){
            fields = Object.assign(fields, {itemDal: null, itemAl: props.itemAl});
        }
        this.state = {fields};
        this.onInputChange = this.onInputChange.bind(this);

    }
    componentWillReceiveProps(nextProps){
        let fields = this.state.fields;
        fields.itemDal = nextProps.itemDal;
        fields.itemAl = nextProps.itemAl;
        this.setState({fields: fields});
    }

    componentDidMount(){
        if (this.props.fireOnChangeOnStart){
            this.props.onChange(this.state.fields.itemDal, this.state.fields.itemAl);
        }
    }

    onInputChange(a1, {name, value}) {
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields });
            this.props.onChange(this.state.fields.itemDal, this.state.fields.itemAl);
        }
    }
    render() {
        return (
            <div className="ui form">
                <div className="inline fields">

                    <Form.Field>
                        <label>Estratto conto dal</label>
                        <Form.Input placeholder='AAAA/NN/L' className="ui input"
                                    name='itemDal' autoComplete="on"
                                    pattern="[0-9][0-9][0-9][0-9]/[0-9][0-9]/[A-Za-z]"
                                    value={this.state.fields.itemDal}
                                    onChange={(a1, {name, value}) => {this.onInputChange(null, {name: 'itemDal', value: value})}}/>
                    </Form.Field>
                    <Form.Field>
                        <label>al</label>
                        <Form.Input placeholder='AAAA/NN/L' className="ui input"
                                    name='itemAl' autoComplete="on"
                                    pattern="[0-9][0-9][0-9][0-9]/[0-9][0-9]/[A-Za-z]"
                                    value={this.state.fields.itemAl}
                                    onChange={(a1, {name, value}) => {this.onInputChange(null, {name: 'itemAl', value: value})}}/>
                    </Form.Field>
                </div>
            </div>
        )
    }
}

EstrattoContoFilter.PropTypes = {
    itemDal: PropTypes.string,
    itemAl: PropTypes.string,
    fireOnChangeOnStart: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

EstrattoContoFilter.defaultProps = {
    fireOnChangeOnStart: false,
};

export default EstrattoContoFilter;



/** WEBPACK FOOTER **
 ** ./src/components/EstrattoContoFilter.js
 **/